type ApiLoadingProps = {
    open?: boolean;
}

const ApiLoading = (props: ApiLoadingProps) => {
    return (props.open ?? false) ? <div id="api-loading">
        <div className="sk-three-bounce">
            <div className="sk-child sk-bounce1"></div>
            <div className="sk-child sk-bounce2"></div>
            <div className="sk-child sk-bounce3"></div>
        </div>
    </div>
    : null
}

export default ApiLoading

